import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { OrderTotalPrice, OrderItem } from 'shared';
import { MarkupCheckoutData } from 'projects/shared/src/lib/models/markup-checkout-data';
import { ISetInspectionFailed } from 'pm-src/dtos/i-set-inspection-failed';
import { InspectionData } from 'pm-src/app/models/inspection-data';
import { ApproveOrder } from 'projects/shared/src/lib/models/approve-order';

export const MARKUP_CHECKOUT_SERVICE_IMPL = new InjectionToken<IMarkupCheckoutService>(
    'markupCheckoutServiceImpl'
);

export interface IMarkupCheckoutService {
    getOrderData(orderQrCode: string): Observable<HttpResponse<MarkupCheckoutData>>;
    approveCheckout(orderID: number): Observable<HttpResponse<ApproveOrder>>;
    requestInspection(orderID: number): Observable<HttpResponse<void>>;
    startInspection(orderQrCode: string): Observable<HttpResponse<InspectionData>>;
    closeInspection(orderID: number): Observable<HttpResponse<ApproveOrder>>;
    setInspectionFailed(
        requestBody: ISetInspectionFailed
    ): Observable<HttpResponse<void>>;
}
